import React from 'react';
import Autosuggest from 'react-autosuggest';

import './SearchCard.css';

export default class SearchCard extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            suggestions: [],
            value: '',
            actions: props.actions,
            activity: props.activity,
            valueReg: '',
            lastLenght: 0
        }
    }

    onChange = (event, { newValue }) => {
        if (newValue === '') {
            this.setState({
                value: newValue,
                valueReg: '',
                lastLenght: 0
            });
        } else {
            const result = this.validingRegex(newValue);

            this.setState({ valueReg: result.regex, lastLenght: result.inputLength, value: newValue });
        }
    };

    validingRegex = (newValue) => {
        let regex = '';
        let inputLength = newValue.length;
		newValue = newValue.toLowerCase();
        if (inputLength > this.state.lastLenght) {
            regex = this.state.valueReg.toLowerCase() + this.replaceToRegex(newValue[newValue.length - 1]);
        } else {
            let newReg = this.state.valueReg;
            if (newReg[newReg.length - 1] === ']') {
                let split = newReg.split('[');
                newReg = newReg.slice(0, -(split[split.length -1].length + 1));
            } else {
                newReg = newReg.substring(0, newReg.length - 1);
            }

            regex = newReg.toLowerCase();
        }

        return {regex, inputLength};
    }

    onSuggestionsFetchRequested = ({ value }) => {
        let sugg = [];
        let regex = '';
        let inputLength = value.length;

        if (value !== '') {
            if (inputLength > this.state.lastLenght) {
                regex = this.state.valueReg + this.replaceToRegex(value[value.length - 1]);
            } else {
                
                const result = this.validingRegex(value);
                regex = result.regex;
            }

            sugg = this.getSuggestions(value, regex);
        }
        this.setState({
            suggestions: sugg,
            regex: regex,
            lastLenght: inputLength
        });
    };

    onSuggestionsClearRequested = () => {
        this.setState({
            suggestions: []
        });
    };

    replaceToRegex = (str) => {
        let result = str;
        const letters = [
            '[aãàáâ]',
            '[eéèê]',
            '[iíì]',
            '[oõòóô]',
            '[uúù]',
            '[cç]'
        ]

        for (let index = 0; index < letters.length; index++) {
            if (letters[index].includes(str)) {
                return letters[index];
            }
        }

        return result;
    }

    getSuggestions = (value, regex) => {
        const inputValue = value.trim().toLowerCase();
        const inputLength = inputValue.length;

        return inputLength === 0 ? [] : this.state.actions.filter(banc => {
            let tittleBanc = banc.title.toLowerCase();

            let valid = new RegExp('.*' + regex.toLowerCase() + '.*');

            return valid.test(tittleBanc);
        }).slice(0, 10);
    };

    getSuggestionValue = suggestion => {
        this.props.store.dispatch({
            type: 'WEB_CHAT/SEND_MESSAGE',
            payload: { text: suggestion.value }
        });
        this.setState({ actions: [] });
        return suggestion.title;
    };

    renderSuggestion = suggestion => (
        <div className='SuggestionsDiv'>
            {suggestion.title}
        </div>
    );

    onKeyDown = (e) => {
        if(e.key === 'Enter' && this.state.suggestions.length === 1) {
            this.getSuggestionValue(this.state.suggestions[0]);
        }
    }

    render() {
        const { value, suggestions, actions, activity } = this.state;

        const inputProps = {
            placeholder: 'Digite o nome do banco',
            value,
            onChange: this.onChange,
            onKeyDown: this.onKeyDown
        };

        return (
            <div className='wrapper_searchcard'>
                <span className='text_bubble'>{activity.text}</span>
                {actions.length > 0 ?
                    <Autosuggest
                        suggestions={suggestions}
                        onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
                        onSuggestionsClearRequested={this.onSuggestionsClearRequested}
                        getSuggestionValue={this.getSuggestionValue.bind(this)}
                        renderSuggestion={this.renderSuggestion.bind(this)}
                        inputProps={inputProps}
                    /> : <div></div>}
            </div>
        );
    }
}